import { useMutation } from 'react-query';
import { downloadCertificationDOCX } from 'apis/project.api';

const useDownloadCertificationDocxFile = () => useMutation(downloadCertificationDOCX);

export default useDownloadCertificationDocxFile;
